import type { CloudGraphWorkItemEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI: CloudGraphWorkItemEntityAti[] = [
	'ati:cloud:graph:work-item',
];
